import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LandingPage } from '@/pages/landing';
import '@/styles/index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root missing');

createRoot(rootEl).render(
  <StrictMode>
    <LandingPage />
  </StrictMode>,
);
